module.exports = __webpack_public_path__ + "media/images/components/map-icons/contacts-map-pin-proportional_candidate-42888bdd45c7a283339f99e1904f9f86.png";